module.exports = __webpack_public_path__ + "img/lk-menu-letter.550cc44a.svg";